import StyleContext from 'isomorphic-style-loader/StyleContext';
import type { PropsWithChildren } from 'react';

import { cleanupStyles, registerStyles } from './css-registry';

const context = {
  insertCss: typeof window !== 'undefined' ? cleanupStyles : registerStyles,
};

/**
 * Provides a context to collect CSS imports on the server and client.
 *
 * On the server, critical-path styles are added to a registry, which can then
 * be used to include styles in the initial response. On the client, styles are
 * injected into the document as they are loaded.
 */
export const StyleProvider = ({ children }: PropsWithChildren) => (
  <StyleContext.Provider value={context}>{children}</StyleContext.Provider>
);

export default StyleProvider;
